import React, { memo } from 'react';
import { Spinner as LoadingSpinner } from '@miroculus/nucleo';
import classnames from 'classnames/bind';
import styles from './LoadingWithText.scss';
const cx = classnames.bind(styles);
const LoadingWithText = memo(({ message, showMessageFirst = false }) => (React.createElement("div", { className: cx('loadingSpinner') },
    React.createElement(LoadingSpinner, null),
    React.createElement("h2", { className: cx('message', { messageFirst: showMessageFirst }) }, message))));
export default LoadingWithText;
